// Included by both faq-page.liquid and faq-section.liquid; the guard keeps a
// second execution on the same page a no-op instead of throwing on the
// top-level class declaration.
if (!window.customElements.get("accordion-faq-item")) {
  class AccordionFaqItem extends HTMLElement {
    constructor() {
      super();
      this.handleTriggerClick = this.handleTriggerClick.bind(this);
      this.isInitialized = false;
    }

    connectedCallback() {
      if (this.isInitialized) {
        return;
      }

      this.trigger = this.querySelector(".faq__trigger");
      this.answer = this.querySelector(".answer");

      if (!this.trigger || !this.answer) {
        return;
      }

      this.trigger.addEventListener("click", this.handleTriggerClick);
      this.setExpanded(this.isExpanded());
      this.isInitialized = true;
    }

    disconnectedCallback() {
      if (!this.trigger) {
        return;
      }

      this.trigger.removeEventListener("click", this.handleTriggerClick);
      this.isInitialized = false;
    }

    handleTriggerClick() {
      this.toggle();
    }

    toggle() {
      this.setExpanded(!this.isExpanded());
    }

    isExpanded() {
      return this.classList.contains("active") || this.trigger?.getAttribute("aria-expanded") === "true";
    }

    setExpanded(isExpanded) {
      this.classList.toggle("active", isExpanded);
      this.trigger.setAttribute("aria-expanded", String(isExpanded));
      this.answer.hidden = !isExpanded;
    }
  }

  window.customElements.define("accordion-faq-item", AccordionFaqItem);
}
